import { render, staticRenderFns } from "./AsiCard.vue?vue&type=template&id=686f1e40&scoped=true"
import script from "./AsiCard.vue?vue&type=script&lang=ts"
export * from "./AsiCard.vue?vue&type=script&lang=ts"
import style0 from "./AsiCard.vue?vue&type=style&index=0&id=686f1e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f1e40",
  null
  
)

export default component.exports